import { RegionPricing } from 'search/types/RegionPricing';
import { BOX_CONDITIONS, SHOE_CONDITIONS } from 'shared/enums/ConditionsEnums';

const getBoxConditionPriorityPricing = (boxConditionsMap: Record<string, any>): RegionPricing => {
  const goodCondition = boxConditionsMap[BOX_CONDITIONS.GOOD_CONDITION];
  if (goodCondition)
    return {
      minRegionalPrice: goodCondition.min_regional_price,
      minRegionalInstantShipPrice: goodCondition.min_regional_instant_ship_price,
    };

  const missingLid = boxConditionsMap[BOX_CONDITIONS.MISSING_LID];
  if (missingLid)
    return {
      minRegionalPrice: missingLid.min_regional_price,
      minRegionalInstantShipPrice: missingLid.min_regional_instant_ship_price,
    };

  const badlyDamaged = boxConditionsMap[BOX_CONDITIONS.BADLY_DAMAGED];
  if (badlyDamaged)
    return {
      minRegionalPrice: badlyDamaged.min_regional_price,
      minRegionalInstantShipPrice: badlyDamaged.min_regional_instant_ship_price,
    };

  return {
    minRegionalPrice: boxConditionsMap[BOX_CONDITIONS.NO_ORIGINAL_BOX].min_regional_price,
    minRegionalInstantShipPrice:
      boxConditionsMap[BOX_CONDITIONS.NO_ORIGINAL_BOX].min_regional_instant_ship_price,
  };
};

export const getRegionPricingVariationsPriority = (
  variationsMap: Record<string, any>,
): RegionPricing => {
  if (!variationsMap) return null;

  // The shoe conditions listed under SHOE_CONDITIONS are the same
  // conditions listed for all products

  const newNoDefects = variationsMap[SHOE_CONDITIONS.NEW_NO_DEFECTS];
  if (newNoDefects) return getBoxConditionPriorityPricing(newNoDefects);

  const newWithDefects = variationsMap[SHOE_CONDITIONS.NEW_WITH_DEFECTS];
  if (newWithDefects) return getBoxConditionPriorityPricing(newWithDefects);

  const goatClean = variationsMap[SHOE_CONDITIONS.GOAT_CLEAN];
  if (goatClean) return getBoxConditionPriorityPricing(goatClean);

  const used = variationsMap[SHOE_CONDITIONS.USED];
  if (used) return getBoxConditionPriorityPricing(variationsMap[SHOE_CONDITIONS.USED]);

  return null;
};
